var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"avify-card",attrs:{"title":_vm.title,"img-src":_vm.imgSrc,"img-top":""}},[_c('b-card-body',[_vm._t("card-body")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }